<template>
  <div>
    <validation-observer ref="form">
      <b-form @submit.prevent="handleSubmit">
        <b-row>
          <b-col cols="12">
            <validation-provider
              v-slot="{ errors }"
              name="Nombre"
              rules="required"
            >
              <b-form-group
                label="Nombre"
                label-for="rt-name"
              >
                <b-form-input
                  id="rt-name"
                  v-model="form.name"
                  placeholder="Ej: Permiso sindical"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <validation-provider
              v-slot="{ errors }"
              name="Comportamiento"
              rules="required"
            >
              <b-form-group
                label="Comportamiento"
                label-for="rt-behavior"
              >
                <b-form-select
                  id="rt-behavior"
                  v-model="form.behavior"
                  :options="behaviorOptions"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label="Tiempo permitido"
              label-for="rt-allowed-time"
            >
              <b-form-input
                id="rt-allowed-time"
                v-model="form.allowed_time"
                placeholder="Ej: 2 días (opcional)"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group>
              <b-form-checkbox
                v-model="form.requires_approval"
                switch
              >
                Requiere aprobación
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>

        <div class="text-right mt-2">
          <b-button
            variant="outline-primary"
            class="mr-1"
            @click="$emit('cancel')"
          >
            Cancelar
          </b-button>
          <b-button
            type="submit"
            variant="primary"
          >
            {{ isEditing ? 'Guardar cambios' : 'Añadir motivo' }}
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mapActions } from 'vuex'
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BFormSelect,
  BButton,
  BRow,
  BCol,
} from 'bootstrap-vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BFormSelect,
    BButton,
    BRow,
    BCol,
  },
  props: {
    requestType: {
      type: Object,
      default: null,
    },
    clientId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      form: {
        name: '',
        behavior: 'justified',
        allowed_time: '',
        requires_approval: true,
      },
      behaviorOptions: [
        { value: 'justified', text: 'Justificada' },
        { value: 'unjustified', text: 'No justificada' },
        { value: 'neutral', text: 'Neutral' },
      ],
    }
  },
  computed: {
    isEditing() {
      return !!this.requestType
    },
  },
  mounted() {
    if (this.requestType) {
      this.form = {
        name: this.requestType.name,
        behavior: this.requestType.behavior,
        allowed_time: this.requestType.allowed_time || '',
        requires_approval: !!this.requestType.requires_approval,
      }
    }
  },
  methods: {
    ...mapActions({
      createRequestType: 'requestTypes/create',
      updateRequestType: 'requestTypes/update',
    }),
    async handleSubmit() {
      const valid = await this.$refs.form.validate()
      if (!valid) return

      const payload = {
        ...this.form,
        allowed_time: this.form.allowed_time || null,
      }

      if (!this.isEditing && this.clientId) {
        payload.client_id = this.clientId
      }

      try {
        if (this.isEditing) {
          await this.updateRequestType({ id: this.requestType.id, data: payload })
        } else {
          await this.createRequestType(payload)
        }
        this.$emit('success')
      } catch {
        // error ya notificado por el store
      }
    },
  },
}
</script>